import { render } from "./RTLBtn.vue?vue&type=template&id=bfec2114&scoped=true&ts=true"
import script from "./RTLBtn.vue?vue&type=script&lang=ts"
export * from "./RTLBtn.vue?vue&type=script&lang=ts"

import "./RTLBtn.vue?vue&type=style&index=0&id=bfec2114&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfec2114"]])

export default __exports__